// src/components/guide/Sidebar.tsx
import SidebarItem from './SidebarItem';
import { useState } from 'react';
import { cn } from '../../utils/helper';
import BlackLogoImg from '../../assets/images/logo/logo_black.svg';
import { GUIDE_NAV_ITEMS, GuideNavItem } from './navConfig';

const normalizeText = (value: string) => value.replace(/\s+/g, '').toLowerCase();

interface SidebarProps {
  brand?: string;
  activeId?: string;
  onSelect?: (item: GuideNavItem) => void;
}

export default function Sidebar({ brand = '가이드', activeId, onSelect }: SidebarProps) {
  const [query, setQuery] = useState('');

  const normalizedQuery = normalizeText(query);
  const hasQuery = normalizedQuery.length > 0;
  const filteredNav = hasQuery
    ? GUIDE_NAV_ITEMS.reduce<GuideNavItem[]>((acc, item) => {
        const normalizedLabel = normalizeText(item.label);
        const selfMatch = normalizedLabel.includes(normalizedQuery);
        if (!item.items) {
          if (selfMatch) acc.push(item);
          return acc;
        }

        const childMatches = item.items.filter((child: GuideNavItem) => {
          const normalizedChildLabel = normalizeText(child.label);
          return normalizedChildLabel.includes(normalizedQuery);
        });

        if (selfMatch) {
          acc.push({
            ...item,
            items: childMatches.length ? childMatches : item.items,
          });
          return acc;
        }

        if (childMatches.length) {
          acc.push({ ...item, items: childMatches });
        }

        return acc;
      }, [])
    : GUIDE_NAV_ITEMS;
  const data = hasQuery ? filteredNav : GUIDE_NAV_ITEMS;

  return (
    <div className="sticky top-0">
      {/* Brand */}
        <a href={'https://xn--sr3b21hbrc97b.net'}>
            <div className="mb-6 flex items-end gap-2">
                <img src={BlackLogoImg} alt="분양의신 로고"/>
            </div>
        </a>

        {/* Search */}
        <label className="group relative block">
            <span className="sr-only">검색</span>
            <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
          placeholder="빠른 검색"
          className={cn(
            'w-full bg-[#F7F7F7] rounded-md border border-gray-200 px-9 py-2 text-sm',
            'placeholder:text-gray-400 focus:ring-2 focus:ring-sky-500 focus:outline-none',
          )}
        />
        <svg
          aria-hidden
          className="pointer-events-none absolute left-2.5 top-1/2 -translate-y-1/2 h-4 w-4 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M12.9 14.32a8 8 0 111.414-1.414l3.387 3.386a1 1 0 01-1.414 1.415l-3.387-3.387zM14 8a6 6 0 11-12 0 6 6 0 0112 0z"
            clipRule="evenodd"
          />
        </svg>
      </label>

      {/* Nav */}
      <nav className="mt-6 space-y-1">
        {data.map((item) => (
          <SidebarItem key={item.id} item={item} activeId={activeId} onItemClick={onSelect} />
        ))}
      </nav>
    </div>
  );
}
